'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var DeviceContext = React.createContext({
    isMobileDevice: false,
    isSmallViewport: false,
});

exports.DeviceContext = DeviceContext;
